export default "__VITE_ASSET__BLyDFasN__"